<template>
  <div>
    <!-- Calendario -->
    <label
      class="font-medium text-grey-30"
      style="color: rgb(11, 11, 11); font-size: 16px;"
    >
      Selecciona el día
    </label>
    <vue-datepicker-ui
      v-model="selectedDate"
      lang="es"
      placeholder="Selecciona el día"
      @change="dateSelected"
      :disabledStartDate="availableDates"
    />

    <!-- Menú desplegable de horas -->
    <div
      v-if="selectedDay && ticketOptions.length > 0"
      class="my-2"
    >
      <XField
        :errors="validationErrors(formattedLabel)"
        :errorStyle="formFieldsErrorStyle"
      >
        <VSelect
          label="Selecciona la hora"
          :labelStyle="labelStyle"
          eSelectLabel="name"
          trackBy="ticket"
          :searchable="false"
          v-model="fieldValue"
          v-validate="{ required: parameters.required }"
          :inputErrorStyle="inputCustomStyles"
          :options="ticketOptions"
          :maxHeight="maxMenuHeight"
          :openDirection="menuOpenDirection"
          :data-vv-name="formattedLabel"
          :invalid="validationHasErrors(formattedLabel)"
          :optional="isOptional"
          :disabled="isDisabled"
          @close="validate"
        >
          <template
            slot="singleLabel"
            slot-scope="{ option }"
          >
            <strong>{{ option.name }}</strong>
          </template>
        </VSelect>

        <div
          v-if="isFullCapacity"
          class="flex items-center rounded bg-warning-60 max-w-sm mx-auto text-white text-sm font-bold px-4 py-3 mb-8"
          role="alert"
        >
          <svg
            class="fill-current w-20 h-20 mr-4"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"><path d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z"/></svg>
          <p>{{ fullCapacityMessage }}</p>
        </div>
      </XField>
    </div>

    <div
      class="my-2"
    >
      <div
        v-if="errorMessage"
        class="flex items-center rounded bg-warning-60 max-w-sm mx-auto text-white text-sm font-bold px-4 py-3"
        role="alert"
      >
        <svg
          class="fill-current w-5 h-5 mr-4"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"><path d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z"/></svg>
        <p>{{ errorMessage }}</p>
      </div>

    </div>

  </div>
</template>

<script>

import gql from 'graphql-tag'
import InputMixin from './InputMixin'
import VueDatepickerUi from 'vue-datepicker-ui'
import 'vue-datepicker-ui/lib/vuedatepickerui.css'
import VSelect from '@plat/components/VueSelect'
import _ from 'lodash'

export default {
  mixins: [InputMixin],
  components: {
    VueDatepickerUi,
    VSelect
  },
  props: {
    ticketTypes: {
      type: Array,
      required: true
    },
    ticketTypesWithPrices: {
      type: Array,
      required: true
    },
    eventWithPayment: {
      type: Boolean,
      requited: true
    },
    eventId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      selectedDay: null,
      selectedHour: null,
      selectedDate: null,
      validDates: [],
      availableDates: {
        to: null,
        from: null
      },
      isDisabled: false,
      isFullCapacity: false,
      ticketAsDefault: '',
      errorMessage: ''
    }
  },
  computed: {

    formattedLabel () {
      return _.lowerCase(this.parameters.config.label)
    },

    maxMenuHeight () {
      return this.parameters.componentOptions
        ? this.parameters.componentOptions.maxHeight || 300
        : 300
    },
    selectClasses () {
      return [...DEFAULT_SELECT_CLASSES, ...COLORS[this.color], this.$style['select'], {
        'cursor-not-allowed text-grey-40': this.disabled,
        'text-grey-40': !this.disabled,
        'border-danger-60 shadow-outline-danger': this.invalid
      }]
    },
    ticketOptions () {
      if (!this.selectedDay) {
        return []
      }

      let eventWithPayment = this.eventWithPayment
      let currencyFormatEUR = this.currencyFormatEUR

      let hours = this.ticketTypesWithPrices
        .filter(ticket => {
          if (ticket.ticket.includes('#')) {
            const ticketDate = new Date(ticket.ticket.split('#')[1].split('_')[0])
            return ticketDate.toDateString() === this.selectedDay.toDateString()
          } else {
            return false // Descartar elementos sin fecha
          }
        })
        .map(ticket => {
          return {
            name: ticket.ticket.split('_')[1] + (eventWithPayment ? ' - ' + currencyFormatEUR(ticket.price) : '') + (this.eventId !== '656989b8-ba80-4741-a43a-b8a2da1121e8' ? '' : (' - TALLER ' + ticket.ticket.split('#')[0])),
            price: ticket.price,
            ticket: ticket.ticket
          }
        })

      return hours
    },

    menuOpenDirection () {
      return this.parameters.componentOptions
        ? this.parameters.componentOptions.openDirection || ''
        : ''
    },

    fullCapacityMessage () {
      return this.$t('common.notifications.messages.fullCapacity')
    }
  },
  mounted () {
    this.calculateAvailableDates()
  },
  methods: {
    // Desactiva todas las fechas del calendario excepto las del intervalo de los tickets
    calculateAvailableDates () {
      if (!this.ticketTypesWithPrices || !Array.isArray(this.ticketTypesWithPrices)) {
        return
      }

      const validDates = this.ticketTypesWithPrices
        .filter(ticket => ticket && typeof ticket.ticket === 'string' && ticket.ticket.includes('#'))
        .map(ticket => {
          const datePortion = ticket.ticket.split('#')[1].split('_')[0]
          return new Date(datePortion)
        })
        .filter(date => date instanceof Date)

      this.validDates = validDates

      if (validDates.length > 0) {
        const earliestDate = new Date(Math.min.apply(null, validDates))
        const latestDate = new Date(Math.max.apply(null, validDates))

        this.availableDates.to = earliestDate
        this.availableDates.from = latestDate
      } else {
        // En caso de que no haya fechas válidas, establecer un rango predeterminado
        const today = new Date()
        this.availableDates.to = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1)
        this.availableDates.from = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1)
      }
    },
    dateSelected (date) {
      var dateExists = false
      const formattedDateToCheck = date.toDateString()
      this.validDates.forEach(dateValid => {
        if (!dateExists && dateValid.toDateString() === formattedDateToCheck) {
          dateExists = true
        }
      })

      if (!dateExists) {
        this.errorMessage = this.$t('common.notifications.messages.invalidDate')
        this.selectedDay = null
      } else {
        this.errorMessage = null
        this.selectedDay = date
      }

      this.fieldValue = {}
    },
    currencyFormatEUR (num) {
      return (
        num
          .toFixed(2) // always two decimal digits
          .replace('.', ',') // replace decimal point character with ,
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + ' €'
      ) // use . as a separator
    },
    async validate () {
      this.$validator.validate(this.formattedLabel)
      this.$emit('loadingTicketType', true)

      if (this.fieldValue) {
        this.$apollo
          .query({
            query: gql`query Event ($eventId: Uuid!, $ticketType: String) {
              event (eventId: $eventId) {
                isRegistrationFullCapacity (ticketType: $ticketType)
              }
            }`,
            fetchPolicy: 'network-only',
            variables: {
              eventId: this.eventId,
              ticketType: this.fieldValue.ticket
            }
          })
          .then(result => {
            this.isFullCapacity = result.data.event.isRegistrationFullCapacity
            this.$emit('ticketTypeFullCapacity', this.isFullCapacity)
            this.$emit('loadingTicketType', false)
          })
      }
    }
  }
}

const DEFAULT_SELECT_CLASSES = [
  'w-full',
  'bg-white',
  'rounded',
  'border',
  'border-solid',
  'border-grey-80',
  'py-2',
  'px-3',
  'outline-none'
]
const COLORS = {
  primary: [
    'focus:shadow-outline-info',
    'focus:border-info-50'
  ],
  secondary: [
    'focus:shadow-outline-info',
    'focus:border-info-50'

  ],
  error: [
    'focus:shadow-outline-danger',
    'focus:border-danger-50'
  ]
}
</script>

<style lang="scss" module>
.select {
  option {
    color: config('colors.grey-30');
  }
}

</style>
